<template>
  <WizardBox title="Import">
    <template v-slot:tools>
      
    </template>
    <template v-slot:content>
      <FormGroup v-bind:form="dataForm">
        <FormWizard ref="importExportWizard" :submitting="submitting" v-bind:tabList="tabList" @finished="submitImportExport">
          <template v-slot:content>
            <FormWizardStep index="1" v-bind:active="true">
              <FormRow label="Type"><FormSelect :options="methodOptions" v-model="importExport.type" field="method" /></FormRow>
              <FormRow label="Resource"><FormSelect :options="resourceOptions" v-model="importExport.resource" field="resource" /></FormRow>
              <FormRow label="Import File"><FormUpload v-model="importExport.uploadFileList" singleFile /></FormRow>
              <FormRow>
                <p class="text-muted">
                  Upload Details:
                  <ol>
                    <li>Files must be CSV type. CSV files can be exported from Excel / Numbers</li>
                    <li>First row must contain the column names to be able to map to system fields</li>
                  </ol>
                </p>
              </FormRow>
            </FormWizardStep>

            <FormWizardStep index="2">
              <StaticDataTable class="static-table-list">
                <template v-slot:header>
                  <tr>
                    <th>Name</th>
                    <th>Field</th>
                    <th>Details</th>
                  </tr>
                </template>
                <template v-slot:body>
                  <tr v-for="(mapping, index) in mappingList" :key="index">
                    <td class="font-weight-bold">{{mapping.name}}</td>
                    <td>{{mapping.field}}</td>
                    <td>{{mapping.description}}</td>
                  </tr>
                </template>
              </StaticDataTable>
            </FormWizardStep>
          </template>
        </FormWizard>
      </FormGroup>
    </template>
  </WizardBox>
</template>

<script>
import _ from 'lodash'
import WizardBox from '@/components/wizardBox'
import StaticDataTable from '@/components/table/staticDataTable.vue'
import form from '@/mixins/form'
import { ImportExportResourceTypes } from '@/store/types'

export default {
  name: "AdminToolImport",
  mixins: [form],
  components: {
    WizardBox,
    StaticDataTable
  },
  data: () => {
    return {
      submitting: false,
      methodOptions: [
        { value: 'import', name: 'Import' },
      ],
      resourceOptions: [
        { value: ImportExportResourceTypes.contact, name: 'Contacts' },
        { value: ImportExportResourceTypes.stock, name: 'Stock' },
        { value: ImportExportResourceTypes.stockCategory, name: 'Stock Category' },
        { value: ImportExportResourceTypes.stockGlassPricing, name: 'Stock - Glass Pricing' },
        { value: ImportExportResourceTypes.stockServicePricing, name: 'Stock - Service Pricing' },
        { value: ImportExportResourceTypes.glassSizes, name: 'Stock - Glass Sizes' },
        { value: ImportExportResourceTypes.glassSupplierBulkPricing, name: 'Stock - Glass Bulk Pricing' },
      ],
      dataForm: {},
      tabList: [
        { title: 'Details' },
        { title: 'Mapping Info' },
      ],
      importExport: {
        type: 'import',
        resource: ImportExportResourceTypes.stock,
        uploadFileList: [],
      },
    };
  },
  mounted() {
  },
  computed: {
    mappingList() {
      return []
      
      // Note: Outdated
      switch(this.importExport.resource) {
        case ImportExportResourceTypes.stock:
          return [
            { name: 'Code', field: 'code', description: 'Unique Stock code' },
            { name: 'Name', field: 'name', description: 'Stock item name' },
            { name: 'Note', field: 'note', description: 'Notes' },
            { name: 'Active', field: 'active', description: 'Boolean if the stock is enabled/active' },
            { name: 'Type', field: 'type', description: 'Stock type. Valid values are: "glass", "glassService", "general"' },
            { name: 'UoM', field: 'uom', description: 'Unit of measurement' },
            { name: 'Thickness', field: 'thickness', description: 'Thickness for glass / general types. In mm' },
            { name: 'Treatment', field: 'treatment', description: 'Treatment. "annealed" or "laminated"' },
            { name: 'Min Offcut Width', field: 'minOffcutWidth', description: 'Minimum offcut width for glass' },
            { name: 'Min Offcut Width', field: 'minOffcutHeight', description: 'Minimum offcut height for glass' },
          ]
        case ImportExportResourceTypes.stockGlassPricing:
          return [
            { name: 'Code', field: 'code', description: 'Unique Stock code' },
            { name: 'Type', field: 'type', description: 'Pricing type/group. Must match the name in the pricing group list in inventory configuration' },
            { name: 'Active', field: 'active', description: 'Boolean if the pricing is enabled/active' },
            { name: 'Price', field: 'price', description: 'Sales price of the glass per square metre. In dollars' },
          ]
        case ImportExportResourceTypes.stockServicePricing:
          return [
            { name: 'Code', field: 'code', description: 'Unique Stock code' },
            { name: 'Type', field: 'type', description: 'Service pricing type. Valid values are: "annealed", "laminated", "toughened"' },
            { name: 'Active', field: 'active', description: 'Boolean if the pricing is enabled/active' },
            { name: 'Price', field: 'price', description: 'Service price of the glass in dollars. Based on UoM of the stock item' },
            { name: 'Min Charge Price', field: 'minChargePrice', description: 'Minimum charge of the service in dollars' },
            { name: 'Minimum Range', field: 'minRange', description: 'Minimum service pricing range. Must match the min range thickness of the service pricing type' },
            { name: 'Maximum Range', field: 'maxRange', description: 'Maximum service pricing range. Must match the max range thickness of the service pricing type' },
          ]
      }
      return []
    }
  },
  methods: {
     submitImportExport() {
      
      this.submitting = true
      this.$data.dataForm = this.clearFormResponse()

      if(this.$data.importExport.type == 'import') {

        var importData = _.clone(this.$data.importExport)

        this.$apiService.adminService.importDataFile(importData)
        .then(response => {
          this.successToast('Data Imported')
          //this.$router.push(`/inventory/stock`)   // temp: disabled
        })
        .catch(err => {
          // Process errors
          this.$data.dataForm = this.processFormResponse(err)
          this.$refs.importExportWizard.displayErrors()
        })
        .finally(() => {
          this.submitting = false
        })
      }
    },
  }
}

</script>